import { Routes } from '@angular/router';

import { courtResolver } from '@shared/resolvers';

import { APP_ROUTES_SEGMENTS } from './core/enums/app-routes-segments.enum';
import { courtGuard, stateGuard } from './core/guards';
import { tenantClearResolver } from './core/resolvers/tenant-clear.resolver';
import { COUNTY_ROUTES } from './core/routing/county-routes';

export const routes: Routes = [
  {
    path: APP_ROUTES_SEGMENTS.params.state,
    canActivateChild: [stateGuard],
    children: [
      {
        title: 'FAMS Start',
        path: '',
        loadChildren: () =>
          import('./home/home.routes').then((r) => r.HOME_ROUTES),
      },
      {
        resolve: { court: courtResolver, tenantClearer: tenantClearResolver },
        canActivateChild: [courtGuard],
        path: APP_ROUTES_SEGMENTS.params.court,
        children: COUNTY_ROUTES,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'VA',
  },
];
